import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {baseUrl} from "../../../../constants/base-url";
import {HttpClient} from "@angular/common/http";
import {TelegramAttachAllParams} from "../types/telegram-attach-all-adverts-modal.types";

@Injectable({
  providedIn: 'root'
})
export class TelegramAttachAllAdvertsApiService {
  private http: HttpClient = inject(HttpClient);

  public telegramAttachAll(telegramAttachAllParams: TelegramAttachAllParams): Observable<void> {
    return this.http.post<void>(`${baseUrl}/record-calendars/telegram/attach-all`, {}, { params: telegramAttachAllParams });
  }
}
